module.exports = __webpack_public_path__ + "static/media/ico-info.75c26b3f.svg";